<div
  class="fixed h-screen w-full top-0 left-0 bg-white flex items-center justify-center"
>
  <div class="text-center">
    <tix-app-loader></tix-app-loader>
  </div>
</div>
